/* Copyright 2022- Martin Kufner */

Object.defineProperties(document, {
    metas: {
        get() {
            const rv = {};
            for(const meta of this.getElementsByTagName('meta')) {
                const [name, ...parts] = meta.name.replace(/\]/g, '').split(/\[/);
                let content = meta.content;
                if(content.startsWith("{") && content.endsWith("}")) {
                    try { content = JSON.parse(meta.content); }
                    catch(e) {}
                }

                if(!parts.length) rv[name] = content;
                else {
                    const content = {},
                        last = parts.pop();
                    parts.reduce((p, c) => p[c] = {}, content)[last] = meta.content;
                    rv[name] = content;
                }
            }
            for(const name in rv) {
                const n = name.replace(/[^a-z0-9_]([a-z])/gi, (_, m) => m.toUpperCase());
                if(n !== name) rv[n] = rv[name];
            }
            return rv;
        }
    },
    meta: {
        value: function (name, content, create = true) {
            let node = this.head.querySelector(`meta[name="${name}"]`);
            if(arguments.length === 1) return node?.content;
            if(content === undefined) return node?.remove();
            if(!node && create) {
                node = this.createElement('meta');
                node.name = name;
                this.head.append(node);
            }
            return node && (node.content = content);
        }
    },
    clearClass: {
        value(klass) {
            for(const n of this.getElementsByClassName(klass)) n.classList.remove(klass);
        }
    },
    removeElementsByClassName: {
        value(klass) {
            for(const n of this.getElementsByClassName(klass)) n.remove(klass);
        }
    },
    getMatchingCSSRules: {
        value(regexp) {
            Array.from(this.styleSheets).flatMap(s => Array.from(s.cssRules)).filter(r => regexp.test(r.selectorText)).map(r => r.cssText);
        }
    },
    addClass: {value(...classList) { document.documentElement.classList.add(...classList.filter(n => n)) }},
    setClass: {
        value(isSet, ...classList) {
            if(classList.length > 1 || this.hasClass(classList[0]) === !isSet)
                return document.documentElement.classList[isSet ? 'add' : 'remove'](...classList.filter(n => n));

        }
    },
    hasClass: {value(arg) { return document.documentElement.classList.contains(arg) }},
    removeClass: {value(...classList) { return document.documentElement.classList.remove(...classList.filter(n => n)) }},
    toggleClass: {value(...classList) { return document.documentElement.classList.toggle(...classList) }},
    toggleDataset: {
        value(prop, value) {
            const ds = document.documentElement.dataset;
            if(ds[prop] === value) delete ds[prop];
            else ds[prop] = value;
        }
    },
    customPropertyNames: {
        get() {
            return Array.from(document.styleSheets)
                .filter(
                    sheet =>
                        sheet.href === null || sheet.href.startsWith(window.location.origin)
                )
                .reduce(
                    (acc, sheet) =>
                        (acc = [
                            ...acc,
                            ...Array.from(sheet.cssRules).reduce(
                                (def, rule) =>
                                    (def =
                                        rule.selectorText === ":root"
                                            ? [
                                                ...def,
                                                ...Array.from(rule.style).filter(name =>
                                                    name.startsWith("--")
                                                )
                                            ]
                                            : def),
                                []
                            )
                        ]),
                    []
                );
        }
    },
});

const ITEMIDMAP = new Map();
const GET_ELEMENTS_FILTER = function(nodes, sel) {
    if(!nodes.length) return null;
    if(sel) switch(typeof sel) {
        case 'number':
            return nodes[sel] || null;
        case 'string':
            return [...nodes].find(n => n.matches(sel)) || null;
        case 'function':
            return [...nodes].find(sel) || null;
    }
    return nodes[0] || null;
}

Object.defineProperties(document, {
    updateItemId: {
        value: function (node, itemid) {
            const oldItemid = node.getAttribute('itemid');
            let set;
            if(itemid) {
                node.setAttribute('itemid', itemid);
                set = ITEMIDMAP.get(itemid);
                if(!set) ITEMIDMAP.set(itemid, set = new Set());
                set.add(node);
                if(!oldItemid || oldItemid === itemid) return;
            }
            else node.removeAttribute('itemid');
            set = ITEMIDMAP.get(oldItemid);
            if(!set) return;
            set.delete(node);
            if(!set.size) ITEMIDMAP.delete(oldItemid);
        },
        writable: false,
        enumerable: false,
        configurable: false
    },
    getElementsByItemid: {
        value(itemid) {
            return [...(ITEMIDMAP.get(itemid) ?? new Set())];
        },
        writable: false,
        enumerable: false,
        configurable: false
    },
    getElementByItemid: {
        value(itemid, sel) {
            return GET_ELEMENTS_FILTER(this.getElementsByItemid(itemid), sel);
        }
    },

    getElementByClassName: {
        value(tagName, sel) {
            return GET_ELEMENTS_FILTER(this.getElementsByClassName(className), sel);
        }
    },

    getElementByTagName: {
        value(tagName, sel) {
            return GET_ELEMENTS_FILTER(this.getElementsByTagName(tagName), sel);
        }
    }
});
// if(!Object.getOwnPropertyDescriptor(document, "readyStatePromise")) {
//     Object.defineProperties(document, {
//         "readyStatePromise": {
//             get() {
//                 const resolve = {},
//                     value = {
//                         complete: new Promise(r => resolve.complete = r),
//                         interactive: new Promise(r => resolve.interactive = r)
//                     };
//                 Object.defineProperty(this, "readyStatePromise", {value, configurable: false, writable: false});
//
//                 const readyStateResolve = (state) => {
//                     switch(state) {
//                         case "complete":
//                             resolve.interactive("interactive");
//                             resolve.complete("complete");
//                             return true;
//                         case "interactive":
//                             resolve.interactive("interactive");
//                     }
//                 }
//                 if(!readyStateResolve(this.readyState)) this.addEventListener('readystatechange', () => readyStateResolve(document.readyState));
//                 return value;
//             },
//             configurable: true
//         },
//         stateComplete: {
//             get() { return this.readyStatePromise.complete; }
//         },
//         stateInteractive: {
//             get() { return this.readyStatePromise.interactive; }
//         }
//     });
// }


